import type { FC, SVGProps } from 'react';

export const CloseXIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="10"
    height="10"
    fill="currentColor"
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.57795 4.99948L8.50764 1.50729C8.55675 1.44925 8.51545 1.36108 8.43956 1.36108H7.54894C7.49648 1.36108 7.44626 1.38452 7.41166 1.4247L4.99536 4.30528L2.57907 1.4247C2.54559 1.38452 2.49536 1.36108 2.44179 1.36108H1.55117C1.47527 1.36108 1.43398 1.44925 1.48309 1.50729L4.41277 4.99948L1.48309 8.49167C1.47209 8.5046 1.46503 8.52042 1.46275 8.53725C1.46048 8.55408 1.46308 8.5712 1.47024 8.5866C1.47741 8.60199 1.48885 8.61501 1.50319 8.62409C1.51754 8.63318 1.53419 8.63796 1.55117 8.63787H2.44179C2.49425 8.63787 2.54447 8.61443 2.57907 8.57425L4.99536 5.69367L7.41166 8.57425C7.44514 8.61443 7.49536 8.63787 7.54894 8.63787H8.43956C8.51545 8.63787 8.55675 8.5497 8.50764 8.49167L5.57795 4.99948Z"
    />
  </svg>
);
